<script>
export default {
  data() {
    return {};
  }
};
</script>

<template lang="pug">
  .no-layout
    slot
</template>

<style lang="scss">
</style>
